<script lang="ts">
    import type { Thread, ThreadId, TransactionId, WorkflowId } from "@repo/backend/types";
    import MailboxThread from "./mailbox-thread.svelte";
    import AssistantIframe from "./assistant-iframe.svelte";

    interface Props {
        threadId: ThreadId;
        transactionId?: TransactionId;
        workflowId?: WorkflowId;
        processingId?: number;
        diffMode?: boolean;
        onThread?: (thread: Thread) => void;
    }

    const { threadId, transactionId, workflowId, processingId, diffMode = false, onThread }: Props = $props();

    let messageIds = $state<string[] | undefined>(undefined);
    let attachmentIds = $state<string[] | undefined>(undefined);

    function onResultLoad(emailParts: { relevantAttachmentIds: string[]; relevantMessageIds: string[] }) {
        attachmentIds = emailParts.relevantAttachmentIds;
        messageIds = emailParts.relevantMessageIds;
    }

    const assistantData = $derived({
        threadId,
        transactionId,
        workflowId,
        processingId,
        diffMode,
    });
</script>

<div class="flex h-full overflow-hidden">
    <div class="flex-1 overflow-hidden border-r">
        <MailboxThread
            {attachmentIds}
            {messageIds}
            deferRenderUntilMessageIds={!!transactionId}
            {threadId}
            {onThread}
        />
    </div>
    <div class="relative h-full flex-[0_0_400px]">
        <AssistantIframe data={assistantData} {onResultLoad} />
    </div>
</div>
